/***
*
*   SIDEBAR
*   Left-hand navigation sidebar matching the Figma design (node 318:16775)
*
*   PROPS
*   items: array of { label, icon, link, action }
*
**********/

import { useContext, useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from 'components/lib';
import Logo from '../../../assets/logo.svg';

// ---------------------------------------------------------------------------
// SVG icons — inline to avoid feather-icons dependency for bespoke Figma icons
// ---------------------------------------------------------------------------

function IconHome() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 7.5L10 2.5L17.5 7.5V17.5H12.5V12.5H7.5V17.5H2.5V7.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    </svg>
  );
}

function IconAccounts() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2C7.79086 2 6 3.79086 6 6C6 8.20914 7.79086 10 10 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      <path d="M3 18C3 15.2386 6.13401 13 10 13C13.866 13 17 15.2386 17 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function IconUsers() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.5 12.5C15.433 12.5 17 11.433 17 10.125C17 8.81696 15.433 7.75 13.5 7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M13.5 12.5C13.5 14.433 11.433 16 8.875 16C6.317 16 4.25 14.433 4.25 12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="8.875" cy="6.5" r="2.75" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <path d="M13.5 7.75C13.5 6.231 12.343 4.875 10.75 4.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

function IconLogs() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3.5" y="2.5" width="13" height="15" rx="1.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <path d="M7 7.5H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M7 10.5H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M7 13.5H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M7 2.5V5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

function IconDashboards() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.5" y="2.5" width="6" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <rect x="2.5" y="12.5" width="6" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <rect x="11.5" y="2.5" width="6" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <rect x="11.5" y="10.5" width="6" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    </svg>
  );
}

function IconSupportTools() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 2.5C6.96243 2.5 4.5 5.04822 4.5 8.1875C4.5 10.2467 5.61626 12.0424 7.25 13V14.5H12.75V13C14.3837 12.0424 15.5 10.2467 15.5 8.1875C15.5 5.04822 13.0376 2.5 10 2.5Z" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <path d="M7.25 16.5H12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M8 18.5H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

function IconAdmin() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 2L3 5V10C3 13.866 6.13401 17.5 10 18C13.866 17.5 17 13.866 17 10V5L10 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    </svg>
  );
}

function IconFeedback() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 3.5H17V13.5H10L6 16.5V13.5H3V3.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      <path d="M7 7.5H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M7 10.5H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

function IconInsights() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <path d="M10 4.5V2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M10 13.5V17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M10 17.5L8 15.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M10 17.5L12 15.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

function IconProductEvents() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 14L7.5 9L10.5 12L13.5 7L17 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="7.5" cy="9" r="1.5" fill="currentColor"/>
      <circle cx="10.5" cy="12" r="1.5" fill="currentColor"/>
      <circle cx="13.5" cy="7" r="1.5" fill="currentColor"/>
      <circle cx="17" cy="11" r="1.5" fill="currentColor"/>
      <circle cx="3" cy="14" r="1.5" fill="currentColor"/>
    </svg>
  );
}

function IconCredits() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="7.5" cy="7.5" r="5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <text x="7.5" y="7.5" fontSize="6" fontWeight="700" fill="currentColor" stroke="none" textAnchor="middle" dominantBaseline="central">C</text>
      <circle cx="12.5" cy="12.5" r="5" stroke="currentColor" strokeWidth="1.5" fill="#fff"/>
      <text x="12.5" y="12.5" fontSize="6" fontWeight="700" fill="currentColor" stroke="none" textAnchor="middle" dominantBaseline="central">C</text>
    </svg>
  );
}

function IconReferrals() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6" cy="7" r="2.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <path d="M2.5 15C2.5 12.79 4.07 11.25 6 11.25C6.7 11.25 7.35 11.45 7.9 11.8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="14" cy="7" r="2.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <path d="M17.5 15C17.5 12.79 15.93 11.25 14 11.25C13.3 11.25 12.65 11.45 12.1 11.8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M8 15.5H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M10.5 13.75L12.25 15.5L10.5 17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function IconChevronLeft() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 12L6 8L10 4" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

// Map label to icon component
const ICON_MAP = {
  home: IconHome,
  accounts: IconAccounts,
  users: IconUsers,
  logs: IconLogs,
  feedback: IconFeedback,
  dashboards: IconDashboards,
  'support tools': IconSupportTools,
  inbox: IconSupportTools,
  admin: IconAdmin,
  insights: IconInsights,
  'internal insights': IconInsights,
  'product events': IconProductEvents,
  referrals: IconReferrals,
  'pro credits': IconCredits,
};

function getInitials(name) {
  if (!name) return '??';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// ---------------------------------------------------------------------------
// Styles
// ---------------------------------------------------------------------------

const styles = {
  sidebar: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '240px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    borderRight: '1px solid #e5e7eb',
    zIndex: 101,
    fontFamily: "'Open Sans', sans-serif",
  },
  logoRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '60px',
    padding: '0 8px 0 12px',
    borderBottom: '1px solid #e5e7eb',
    flexShrink: 0,
  },
  logoImg: {
    height: '22px',
    width: 'auto',
    maxWidth: '150px',
    display: 'block',
  },
  collapseBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    borderRadius: '10px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: '8px',
    flexShrink: 0,
  },
  menuContainer: {
    flex: '1 0 0',
    padding: '12px 8px',
    overflowY: 'auto',
    minHeight: 0,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    height: '40px',
    padding: '8px 12px',
    borderRadius: '10px',
    textDecoration: 'none',
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
    width: '100%',
    textAlign: 'left',
    color: '#364153',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.5,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    transition: 'background-color 0.15s ease',
  },
  navItemDefault: {
    backgroundColor: 'transparent',
    color: '#364153',
  },
  navItemActive: {
    backgroundColor: '#eff6ff',
    color: '#1974f9',
  },
  navItemHover: {
    backgroundColor: '#f8faff',
  },
  navLabel: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: 0,
  },
  userRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    height: '60px',
    padding: '0 12px',
    borderTop: '1px solid #e5e7eb',
    flexShrink: 0,
  },
  avatar: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #ad46ff 0%, #f6339a 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  avatarText: {
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  userName: {
    color: '#364153',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.5,
    whiteSpace: 'nowrap',
  },
  userRole: {
    color: '#6a7282',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 1.5,
    whiteSpace: 'nowrap',
  },
};

// ---------------------------------------------------------------------------
// NavItem wrapper — handles link vs action items
// ---------------------------------------------------------------------------

function NavItem({ item, collapsed }) {
  const IconComponent = ICON_MAP[item.label?.toLowerCase()];

  const iconStyle = (isActive) => ({
    flexShrink: 0,
    color: isActive ? '#1974f9' : '#364153',
    display: 'flex',
    alignItems: 'center',
  });

  const collapsedItemStyle = collapsed
    ? { justifyContent: 'center', padding: '8px', gap: 0 }
    : {};

  if (item.link) {
    return (
      <NavLink
        to={item.link}
        title={collapsed ? item.label : undefined}
        style={({ isActive }) => ({
          ...styles.navItem,
          ...(isActive ? styles.navItemActive : styles.navItemDefault),
          ...collapsedItemStyle,
        })}
      >
        {({ isActive }) => (
          <>
            {IconComponent && (
              <span style={iconStyle(isActive)}>
                <IconComponent />
              </span>
            )}
            {!collapsed && <span style={styles.navLabel}>{item.label}</span>}
          </>
        )}
      </NavLink>
    );
  }

  // action item (e.g. Sign Out)
  return (
    <div
      onClick={item.action}
      title={collapsed ? item.label : undefined}
      style={{ ...styles.navItem, cursor: 'pointer', ...collapsedItemStyle }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && item.action?.()}
    >
      {IconComponent && (
        <span style={{ ...iconStyle(false) }}>
          <IconComponent />
        </span>
      )}
      {!collapsed && <span style={styles.navLabel}>{item.label}</span>}
    </div>
  );
}

// ---------------------------------------------------------------------------
// Sidebar
// ---------------------------------------------------------------------------

const COLLAPSE_KEY = 'mc_sidebar_collapsed';

export function Sidebar({ items, onCollapsedChange }) {
  const context = useContext(AuthContext);
  const user = context?.user;
  const userName = user?.name || 'Admin';
  const userRole = user?.permission ? (user.permission.charAt(0).toUpperCase() + user.permission.slice(1)) : 'Admin';
  const initials = getInitials(userName);

  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem(COLLAPSE_KEY) === 'true'; }
    catch { return false; }
  });

  useEffect(() => {
    try { localStorage.setItem(COLLAPSE_KEY, String(collapsed)); }
    catch { /* ignore */ }
    onCollapsedChange?.(collapsed);
  }, [collapsed, onCollapsedChange]);

  const toggle = () => setCollapsed((c) => !c);

  const sidebarStyle = {
    ...styles.sidebar,
    width: collapsed ? '56px' : '240px',
    transition: 'width 0.2s ease',
    overflow: 'hidden',
  };

  const logoRowStyle = {
    ...styles.logoRow,
    justifyContent: collapsed ? 'center' : 'space-between',
    padding: collapsed ? '0' : '0 8px 0 12px',
  };

  const chevronStyle = {
    display: 'inline-block',
    transition: 'transform 0.2s ease',
    transform: collapsed ? 'rotate(180deg)' : 'rotate(0deg)',
  };

  return (
    <nav style={sidebarStyle} aria-label="Main navigation">

      {/* Logo row */}
      <div style={logoRowStyle}>
        {!collapsed && (
          <img
            src={Logo}
            alt="Law Cyborg"
            style={styles.logoImg}
          />
        )}
        <button
          style={styles.collapseBtn}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          onClick={toggle}
        >
          <span style={chevronStyle}>
            <IconChevronLeft />
          </span>
        </button>
      </div>

      {/* Nav links */}
      <div style={styles.menuContainer}>
        <div style={styles.list}>
          {items?.map((item) => (
            <NavItem key={item.label} item={item} collapsed={collapsed} />
          ))}
        </div>
      </div>

      {/* User profile */}
      <div style={{ ...styles.userRow, justifyContent: collapsed ? 'center' : undefined, padding: collapsed ? '0' : '0 12px' }}>
        <div style={styles.avatar}>
          <span style={styles.avatarText}>{initials}</span>
        </div>
        {!collapsed && (
          <>
            <div>
              <div style={styles.userName}>{userName}</div>
              <div style={styles.userRole}>{userRole}</div>
            </div>
            <button
              onClick={() => context.signout()}
              title="Sign out"
              style={{
                marginLeft: 'auto',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '6px',
                borderRadius: '6px',
                color: '#6a7282',
                display: 'flex',
                alignItems: 'center',
                flexShrink: 0,
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#f3f4f6'}
              onMouseLeave={e => e.currentTarget.style.background = 'none'}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
            </button>
          </>
        )}
      </div>

    </nav>
  );
}
